export default __webpack_public_path__ + "static/media/advertisement.56139ce2.jpg";